import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Popconfirm } from 'antd';

import { IconDelete, IconEdit, IconSetting, IconUser } from '../../../../data/assets/icons';

const TableCellAction = (props) => {
    const { align_right, align_center, show_edit, show_delete, show_setting, show_user, handleUserClick, handleEditClick, delete_popconfirm_title, handleDeleteClick, handleSettingClick } = props;

    return (
        <div className={classNames("ori-flex-row", { "ori-flex-jfe": align_right, "ori-flex-jc": align_center })}>
            {
                show_user &&
                <div className="ori-pad-5 ori-flex-column ori-flex-jc ori-cursor-ptr ori-r-mrgn-5 ori-font-light-hover-primary workflowIcon" onClick={handleUserClick} >
                    <IconUser size={16} />
                </div>
            }
            {
                show_setting &&
                <div className="ori-pad-5 ori-flex-column ori-flex-jc ori-cursor-ptr ori-r-mrgn-5 ori-font-light-hover-primary workflowIcon" onClick={handleSettingClick} >
                    <IconSetting size={16} />
                </div>
            }
            {
                show_edit &&
                <div className="ori-pad-5 ori-flex-column ori-flex-jc ori-cursor-ptr ori-r-mrgn-5 ori-font-light-hover-primary workflowIcon" onClick={handleEditClick} >
                    <IconEdit size={16} />
                </div>
            }
            {
                show_delete &&
                <Popconfirm placement="topRight" title={delete_popconfirm_title} okText="Yes" cancelText="No" onConfirm={handleDeleteClick}>
                    <div className="ori-pad-5 ori-flex-column ori-flex-jc ori-cursor-ptr ori-font-light-hover-primary workflowIcon">
                        <IconDelete size={16} />
                    </div>
                </Popconfirm>
            }
        </div>
    );
}

TableCellAction.propTypes = {
    align_right: PropTypes.bool,
    align_center: PropTypes.bool,
    handleUserClick: PropTypes.func,
    handleEditClick: PropTypes.func,
    handleDeleteClick: PropTypes.func,
    handleSettingClick: PropTypes.func,
    delete_popconfirm_title: PropTypes.string,
    show_edit: PropTypes.bool,
    show_delete: PropTypes.bool,
    show_setting: PropTypes.bool,
    show_user: PropTypes.bool,
};

TableCellAction.defaultProps = {
    align_right: false,
    align_center: false,
    delete_popconfirm_title: "Are you really want to delete this item ?",
    show_edit: false,
    show_delete: false,
    show_setting: false,
    show_user: false,
};

export default TableCellAction;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/tablecellaction/index.js